import useUserCredentialsStore from "../stores/useUserCredentialsStore";

const useIsUserSignedIn = () => {
  const isSignedIn = useUserCredentialsStore(state => state.getIsSignedIn)?.();
  return isSignedIn;
};

export default useIsUserSignedIn;
